import { Box, TextField } from '@mui/material';
import React, { FC, useRef, useState } from 'react';
import { CONFIRM_CODE_BOXES } from '../../../constants/numbers';

interface IConfirmCodeInputGroup {
	values: string[];
	setValues: (vals: string[]) => void;
	numInputs?: number;
}

const ConfirmCodeInputGroup: FC<IConfirmCodeInputGroup> = ({ setValues, values, numInputs = CONFIRM_CODE_BOXES }) => {
	const [_, setIsFocused] = useState(false);
	const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

	const handleChange = (index: number, value: string) => {
		if (/^\d?$/.test(value)) {
			const newValues = [...values];
			newValues[index] = value;
			setValues(newValues);

			if (value && index > 0) {
				inputsRef.current[index - 1]?.focus();
			}
		}
	};

	const handleKeyDown = (index: number, event: React.KeyboardEvent) => {
		if (event.key === 'Backspace' && !values[index] && index < numInputs - 1) {
			inputsRef.current[index + 1]?.focus();
		}
	};

	const handlePaste = (event: React.ClipboardEvent) => {
		const paste = event.clipboardData.getData('text');
		if (new RegExp(`^\\d{${numInputs}}$`).test(paste)) {
			const newValues = paste.split('');
			setValues(newValues);
			inputsRef.current[numInputs - 1]?.focus();
		}
	};

	const handleFocus = () => {
		setIsFocused(true);
	};

	const handleBlur = () => {
		setIsFocused(false);
	};

	return (
		<Box className="my-8 flex items-center justify-center gap-x-6" onPaste={handlePaste}>
			{Array.from({ length: numInputs }, (_, index) => (
				<TextField key={index} className="h-12 w-14" value={values[index] || ''} onFocus={handleFocus} onBlur={handleBlur} onChange={e => handleChange(index, e.target.value)} onKeyDown={e => handleKeyDown(index, e)} inputRef={el => (inputsRef.current[index] = el)} inputProps={{ maxLength: 1, className: 'text-center' }} variant="outlined" />
			))}
		</Box>
	);
};

export default ConfirmCodeInputGroup;
